import { inject, Injectable } from '@angular/core';
import { TranslationService } from './translation.service';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION } from './i18n.shared';

@Injectable({providedIn: 'root'})
export class TranslationServiceStoreAdapter {
  store = inject(Store);
  service = inject(TranslationService);

  constructor() {
    this.store.observe(SOFTLINE_FEATURE_TRANSLATION).subscribe((state: any) => {
      for(const translation of state.translations) {
        if (this.service.translationFiles().findIndex(o => o.language === translation.language && o.module === translation.module) === -1)
          this.service.addFile(translation);
      }
    });
  }
}
